import * as exifr from "exifr";

const MAX_SIZE = 1024;

export const getOrientedFile = async (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async (event) => {
      const img = new Image();

      img.onload = async () => {
        try {
          // ✅ Read orientation safely with exifr
          let orientation: number = (await exifr.orientation(file)) || 1;

          let width = img.width;
          let height = img.height;

          // ✅ Prevent double-rotation
          const isPortrait = height > width;
          if ((orientation === 6 || orientation === 8) && isPortrait) {
            orientation = 1;
          }
          if (orientation === 3 && !isPortrait) {
            orientation = 1;
          }

          // ✅ Resize if too large
          if (Math.max(width, height) > MAX_SIZE) {
            const ratio = MAX_SIZE / Math.max(width, height);
            width = width * ratio;
            height = height * ratio;
          }

          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d")!;

          if (orientation > 4) {
            canvas.width = height;
            canvas.height = width;
          } else {
            canvas.width = width;
            canvas.height = height;
          }

          // ✅ Apply orientation
          switch (orientation) {
            case 2:
              ctx.transform(-1, 0, 0, 1, width, 0);
              break; // Flip X
            case 3:
              ctx.transform(-1, 0, 0, -1, width, height);
              break; // 180°
            case 4:
              ctx.transform(1, 0, 0, -1, 0, height);
              break; // Flip Y
            case 5:
              ctx.transform(0, 1, 1, 0, 0, 0);
              break; // 90° + flip
            case 6:
              ctx.transform(0, 1, -1, 0, height, 0);
              break; // 90° right
            case 7:
              ctx.transform(0, -1, -1, 0, height, width);
              break; // 90° left + flip
            case 8:
              ctx.transform(0, -1, 1, 0, 0, width);
              break; // 90° left
            default:
              break; // leave as is
          }

          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              if (!blob) return reject(new Error("Failed to convert image"));
              resolve(new File([blob], file.name, { type: file.type }));
            },
            file.type,
            0.95,
          );
        } catch (err) {
          console.warn("EXIF processing failed, fallback to original file", err);
          resolve(file); // fallback safe
        }
      };

      img.onerror = (err) => reject(err);
      img.src = event.target?.result as string;
    };

    reader.onerror = (err) => reject(err);
    reader.readAsDataURL(file);
  });
};
